// src/components/Onboarding/NavigationTour.tsx
import React, { useEffect } from 'react';
import Tooltip from './Tooltip';
import { Step } from './Onboarding';
import { Button } from '../ui/atoms/Button/Button';

export const STEPS: Step[] = [
  {
    path: 'home',
    text: 'This is your Home feed—hand-picked recipes just for you. Tap a recipe to dive in.',
    placement: 'bottom',
  },
  {
    path: 'search',
    text: 'Here’s Search—find recipes by name, ingredients, or filters like Vegan, Keto, or Low Sugar.',
    placement: 'bottom',
  },
  {
    path: 'recipe/37609e11-231b-445d-8099-cd6bf89de3e1',
    text: 'Tap “Add to Meal Plan” to schedule this meal on your weekly calendar.',
    placement: 'top',
  },
  {
    path: 'shopping-list',
    text: 'Turn your planned meals into a shopping list with one click.',
    placement: 'mid',
  },
  {
    path: 'recipe/37609e11-231b-445d-8099-cd6bf89de3e1',
    text: 'Unlock full nutrition facts, allergy alerts, and diet filters with Premium.',
    placement: 'mid',
  },
];

interface Props {
  stepIndex: number;
  tourSteps: Step[];
  onNext: () => void;
}

export default function NavigationTour({
  stepIndex,
  tourSteps,
  onNext,
}: Props) {
  const { text, placement = 'mid' } = tourSteps[stepIndex];
  const current = stepIndex + 1;
  const total = tourSteps.length;

  useEffect(() => {
    // map each stepIndex to its nav‐button key
    const highlightMap: Record<number, string> = {
      0: 'home',
      1: 'search',
      2: 'mealplan',
      3: 'shoppinglist',
    };
    const key = highlightMap[stepIndex];
    if (!key) return;

    const classes = [
      'ring-2',           
      'ring-purple-300',  
      'ring-offset-2',    
      'ring-offset-white',
      'shadow-[inset_0_0_0_2px_rgba(255,255,255,0.6),0_0_0_4px_rgba(192,132,252,0.6)]'
    ];
    let cancelled = false;

    function tryHighlight() {
      if (cancelled) return;
      const el = document.getElementById(`nav-${key}`);
      if (el) {
        el.classList.add(...classes);
      } else {
        // retry in 50ms if nav isn't mounted yet
        setTimeout(tryHighlight, 50);
      }
    }

    tryHighlight();

    return () => {
      cancelled = true;
      const el = document.getElementById(`nav-${key}`);
      if (el) el.classList.remove(...classes);
    };
  }, [stepIndex]);

  return (
    <Tooltip text={text} placement={placement}>
      <div className="w-full flex justify-end items-center space-x-2 pt-2">
        <span className="text-xs opacity-80 text-black">
          Step {current} of {total}
        </span>
        <Button onClick={onNext} variant="default-rounded" className="rounded-full">
          Next
        </Button>
      </div>
    </Tooltip>
  );
}
